(function ($) {
  $(document).ready(function () {
    initFooterToggle();
    scrollParallax();
    initSlickSlider();
    updateUnderline();
    handleStickyHeader();

    if ($('facet-filters-form .mobile-facets__summary').length) {
      $('facet-filters-form .mobile-facets__summary').click(function () {
        const parentDetails = $(this).closest('details');
        $('facet-filters-form details').not(parentDetails).removeAttr('open');
      });
    }

    if ($('.menu-drawer__navigation-label').length) {
      $('.menu-drawer__navigation-label').each(function () {
        $(this).click(function () {
          $('.menu-drawer__navigation-label').removeClass('active');
          $(this).addClass('active');
          const id = $(this).data('id');

          if ($(`.menu-drawer__navigation-links__block[data-id="${id}"]`).length) {
            $('.menu-drawer__navigation-links__block').removeClass('active');
            $(`.menu-drawer__navigation-links__block[data-id="${id}"]`).addClass('active');
          }
          updateUnderline();
        });
      });
    }

    $(document).on('click', '.menu-drawer__navigation-link__menu details', function () {
      if (!this.open) {
        $('.menu-drawer__navigation-link__menu details').not(this).prop('open', false);
      }
    });

    $('.header__icons .header__search > details').on('toggle', function () {
      $('.header-outer-wrapper').toggleClass('search-open');

      if ($('.shopify-section.menu-open').length) {
        $('.header header-drawer .menu-drawer-container').removeAttr('open');
        $('.shopify-section.menu-open').removeClass('menu-open');
        $('body').removeClass('overflow-hidden-tablet');
      }
    });

    $('.popup-product-cta').magnificPopup({
      type: 'inline',
      closeOnContentClick: true,
      mainClass: 'product-popup-cta',
    });

    $('.popup-close').on('click', function (e) {
      e.preventDefault();
      $.magnificPopup.close();
    });

    $('.js-toggle-size-modal').magnificPopup({
      type: 'inline',
      mainClass: 'mfp-fade',
      closeOnBgClick: true,
      closeBtnInside: false,
      closeOnContentClick: false,
      alignTop: true,
      removalDelay: 500,
    });

    // Wishlist state
    if (window.SwymCallbacks) {
      window.SwymCallbacks.push(function (swat) {
        if (swat.fetchLists) {
          swat.fetchLists({
            callbackFn: function (lists) {
              if (lists.length && lists[0].listcontents.length) {
                $('.header__icon--wishlist').addClass('has-wishlist-items');
              }
            },
            errorFn: function (error) {
              console.error('Error fetching swym lists:', error);
            },
          });
        }
      });
    }
    // MegaMenus
    var megaMenuTimeout;

    $('.header__inline-menu li').each(function () {
      var $item = $(this);
      var menuHandle = $item.data('menu-handle');
      var $megaMenu = $(".mega-menu[data-menu-handle='" + menuHandle + "']");
      var $header = $('.header-wrapper');
      var $headerOuter = $('.header-outer-wrapper');

      if ($megaMenu.length > 0) {
        $item.on('mouseenter', function () {
          clearTimeout(megaMenuTimeout);
          $('.mega-menu').removeClass('active'); // Remove active class from other menus
          $megaMenu.addClass('active');
          $header.addClass('mega-menu-open');
          $headerOuter.addClass('mega-menu-open');
        });

        $item.on('mouseleave', function () {
          megaMenuTimeout = setTimeout(function () {
            if (!$('.mega-menu:hover').length) {
              $('.mega-menu').removeClass('active');
              $header.removeClass('mega-menu-open');
              $headerOuter.removeClass('mega-menu-open');
            }
          }, 400);
        });

        $megaMenu.on('mouseenter', function () {
          clearTimeout(megaMenuTimeout);
        });

        $megaMenu.on('mouseleave', function () {
          megaMenuTimeout = setTimeout(function () {
            $('.mega-menu').removeClass('active');
            $header.removeClass('mega-menu-open');
            $headerOuter.removeClass('mega-menu-open');
          }, 400);
        });

        $item.on('click', function (e) {
          if ($(window).width() < 1024) {
            e.preventDefault();
            $('.mega-menu').removeClass('active'); // Close other open menus
            $megaMenu.addClass('active');
            $header.addClass('mega-menu-open');
            $headerOuter.addClass('mega-menu-open');
          }
        });

        $(document).on('click', function (e) {
          if (!$(e.target).closest('.header__inline-menu, .mega-menu').length) {
            $('.mega-menu').removeClass('active');
            $header.removeClass('mega-menu-open');
            $headerOuter.removeClass('mega-menu-open');
          }
        });
      }
    });

    // Cart

    $('.header__icon--cart').on('click', function (e) {
      e.preventDefault();
      $('cart-drawer.drawer').addClass('animate');
      $('cart-drawer.animate').addClass('active');
    });

    // Size guide switchs

    $(document).on('click', '.content-tabs a', function (e) {
      e.preventDefault();

      // Remove active class from all tabs
      $('.content-tabs a').removeClass('active');
      $(this).addClass('active');

      // Hide all tab content
      $('.size-tab-content').removeClass('active');

      // Show the corresponding tab content
      var target = $(this).attr('href');
      $(target).addClass('active');
    });

    $(document).on('click', 'input[name="sizeRadio"]', function () {
      var selectedValue = $(this).val();

      if (selectedValue === 'cm') {
        // Show cm size table and hide inches
        $('.cm.size-table').show();
        $('.inches.size-table').hide();
      } else {
        // Show inches size table and hide cm
        $('.inches.size-table').show();
        $('.cm.size-table').hide();
      }
    });

    // if (Cookies.get('popup') == 'displayed') {
    //   $('.popup-product-cta').trigger('click');
    // } else {
    //   setTimeout(function () {
    //     $('.popup-product-cta').trigger('click');
    //     Cookies.set('popup', 'displayed', { expires: 1 });
    //   }, 500);
    // }

    // read more read less
    $('.read-more-btn').click(function (event) {
      event.preventDefault();
      var fullDesc = $(this).siblings('.full-description');
      var shortDesc = $(this).siblings('.short-description');

      if (fullDesc.is(':visible')) {
        fullDesc.hide();
        shortDesc.slideDown();
        $(this).text('Read More');
      } else {
        shortDesc.hide();
        fullDesc.slideDown();
        $(this).text('Read Less');
      }
    });

    // Set ATC button state to active when size option is selected (currently selected by default)
    if ($('.product-form__input--pill input[type="radio"]').length) {
      $('.product-form__input--pill input[type="radio"]').change(function () {
        $('.product-form__buttons button').addClass('size-selected');
      });

      if ($('.product-form__input--pill input[type="radio"]:checked').length) {
        $('.product-form__buttons button').addClass('size-selected');
      }
    }

    // Product accordion
    var speed = 300;

    $('.product__accordion .accordion-button').on('click', function (event) {
      event.preventDefault();

      var $button = $(this);
      var $accordionContent = $button.siblings('.accordion__content');

      // Close all other accordions globally
      $('.accordion-button').not($button).removeClass('open');
      $('.accordion__content').not($accordionContent).slideUp(speed);

      // Toggle current accordion
      if ($button.hasClass('open')) {
        $accordionContent.slideUp(speed);
        $button.removeClass('open');
      } else {
        $accordionContent.slideDown(speed);
        $button.addClass('open');
      }
    });

    // FAQ Accordion

    $('.faq-item .question').on('click', function (e) {
      e.preventDefault();
      if ($(this).hasClass('active')) {
        $(this).parent('.faq-item').removeClass('open');
        $(this).next().slideUp(speed);
        $(this).removeClass('active');
      } else {
        $(this).next().slideDown(speed);
        $(this).parent('.faq-item').addClass('open');
        $(this).addClass('active');
      }
    });

    var allspeed = 800;

    $('.show-all-button').on('click', function (e) {
      e.preventDefault();
      if ($(this).hasClass('active')) {
        $('.show-all-wrapper').slideUp(allspeed);
        $(this).removeClass('active');
        $(this).text('Show all');
      } else {
        $('.show-all-wrapper').slideDown(allspeed);
        $(this).addClass('active');
        $(this).text('Show less');
      }
    });

    if ($(window).width() < 767) {
      $('.mobile-trigger').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('active')) {
          $(this).next('.mobile-content').slideUp(speed);
          $(this).removeClass('active');
        } else {
          $(this).next('.mobile-content').slideDown(speed);
          $(this).addClass('active');
        }
      });
    }

    $('.read-more-container .read-more').on('click', function (e) {
      e.preventDefault();
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('.description-full-read-more').slideUp(300);
        $(this).text('More information');
      } else {
        $(this).addClass('active');
        $('.description-full-read-more').slideDown(300);
        $(this).text('Less information');
      }
    });

    $('.read-more-text-container .read-more').on('click', function (e) {
      e.preventDefault();
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).siblings('.read-more-text').slideUp(300);
        $(this).text('Read more');
      } else {
        $(this).addClass('active');
        $(this).siblings('.read-more-text').slideDown(300);
        $(this).text('Read less');
      }
    });

    // Ajax load more
    $(document).on('click', '.js-load-more', function () {
      var $this = $(this),
        totalPages = parseInt($('[data-total-pages]').val(), 10),
        currentPage = parseInt($('[data-current-page]').val(), 10);

      // Disable the button and show the loader
      $this.attr('disabled', true);
      $this.find('[load-more-text]').addClass('hide');
      $this.find('[loader]').removeClass('hide');

      // Increment the current page
      currentPage++;
      $('[data-current-page]').val(currentPage);

      // Get the current filters selected (e.g., tags, product type, etc.)
      var selectedFilters = ''; // Build this string from your facets selection
      $('.facet-input:checked').each(function () {
        selectedFilters += '&' + $(this).attr('name') + '=' + $(this).val();
      });

      // Construct the next URL (Ensure the page and filters are appended correctly)
      var nextUrl =
        $('[data-next-url]')
          .val()
          .replace(/page=\d*/, 'page=' + currentPage) + selectedFilters;

      // Fetch the next set of products
      $.ajax({
        url: nextUrl,
        type: 'GET',
        dataType: 'html',
        success: function (responseHTML) {
          var newContent = $(responseHTML).find('#product-grid').html();
          $('#product-grid').append(newContent);

          // Hide the button if on the last page
          if (currentPage >= totalPages) {
            $this.hide();
          } else {
            // Update next URL for the subsequent page
            var updatedNextUrl = $(responseHTML).find('[data-next-url]').val();
            $('[data-next-url]').val(updatedNextUrl);
          }
        },
        complete: function () {
          $this.attr('disabled', false);
          $this.find('[load-more-text]').removeClass('hide');
          $this.find('[loader]').addClass('hide');
        },
      });
    });

    $('.mobile-slider-multi .slider').each(function () {
      const $slider = $(this);
      const $progressBar = $slider.siblings('.slider-progress-bar').find('.slider-progress');

      // Function to update the progress bar
      function updateProgress() {
        const maxScrollLeft = $slider[0].scrollWidth - $slider[0].clientWidth;
        const scrollLeft = $slider.scrollLeft();
        const progress = (scrollLeft / maxScrollLeft) * 100;
        $progressBar.css('width', progress + '%');
      }

      // Initialize progress based on current scroll position
      $slider.on('load', function () {
        // Wait for images or items to load, if necessary
        updateProgress();
      });

      // Update progress bar on scroll
      $slider.on('scroll', updateProgress);

      // Set the initial progress bar width
      const totalItems = $slider.children('li').length;
      const initialScrollPosition = totalItems > 0 ? 100 / totalItems : 0;
      $progressBar.css('width', initialScrollPosition + '%');
    });

    let currentGridLayout = $('#product-grid').data('grid');
    let currentCardView = $('.facet-filters__views-card div.active').data('view');

    if ($('.facet-filters__views-grid').length) {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const viewFromUrl = urlParams.get('grid-view');
        const cardViewFromUrl = urlParams.get('card-view');

        if (viewFromUrl) {
          currentGridLayout = viewFromUrl;

          updateGridLayout(currentGridLayout);
        }

        if (cardViewFromUrl) {
          currentCardView = cardViewFromUrl;

          handleProductCardView(currentCardView);
        } else {
          setTimeout(() => {
            handleProductCardView('model');
          },0)
        }
      } catch (e) {
        if (window.innerWidth <= 768) {
          $(".facet-filters__views-grid div[data-view='2']").trigger('click');
        }
      }

      $('.facet-filters__views-grid div').click(function () {
        const selectedView = $(this).data('view');
        $('.facet-filters__views-grid div.active').removeClass('active');
        $(this).addClass('active');

        currentGridLayout = selectedView;

        updateGridLayout(selectedView);
        handleQueryString('grid-view', selectedView);

        $('.card__slider').each(function () {
          if ($(this).hasClass('slick-initialized')) {
            $(this).slick('setPosition');
          }
        });
      });
    }
    subscribe(PUB_SUB_EVENTS.filterRender, function () {
      initProductCards();
      document.dispatchEvent(new CustomEvent('swym:collections-loaded'));

      updateGridLayout(currentGridLayout);
      handleProductCardView(currentCardView);

      handleQueryString('grid-view', currentGridLayout);
      handleQueryString('card-view', currentCardView);
      $(window).trigger('resize');
    });

    function getCurrentPageSlug() {
      const path = window.location.pathname;
      const segments = path.split('/').filter((segment) => segment.length > 0);

      return segments[segments.length - 1] || 'home';
    }

    function removeQueryParams(paramsToRemove) {
      const url = new URL(window.location);

      paramsToRemove.forEach((param) => {
        url.searchParams.delete(param);
      });

      window.history.replaceState({}, '', url.toString());
    }

    function handlePageSlugChange() {
      try {
        const currentSlug = getCurrentPageSlug();
        const storedSlug = sessionStorage.getItem('previousPageSlug');

        if (storedSlug && storedSlug !== currentSlug) {
          removeQueryParams(['grid-view', 'card-view']);

          updateGridLayout(window.innerWidth >= 1024 ? 4 : 2);
        }

        sessionStorage.setItem('previousPageSlug', currentSlug);
      } catch (error) {
        console.warn('Session storage not available:', error);
      }
    }

    handlePageSlugChange();

    function updateGridLayout(view) {
      const paginationLinks = $('.product-grid-container .collection .pagination__item[href]');

      paginationLinks.each(function () {
        try {
          const link = $(this);
          const originalHref = link.attr('href');
          if (originalHref) {
            const url = new URL(originalHref, window.location.origin + window.location.pathname);
            url.searchParams.set('grid-view', String(view));
            link.attr('href', url.pathname + url.search + url.hash);
          }
        } catch (e) {
          console.error('Error updating pagination link:', e, this);
        }
      });

      $('.facet-filters__views-grid div[data-view].active').removeClass('active');
      $(`.facet-filters__views-grid div[data-view="${view}"]`).addClass('active');
      $('#product-grid').attr('data-grid', view);

      if (parseInt(view) === 8 || (parseInt(view) === 4 && window.innerWidth < 768)) {
        setTimeout(() => {
          handleProductCardView('item');
        }, 0);
      } else {
        setTimeout(() => {
          handleProductCardView('model');
        }, 0);
      }
    }

    function handleQueryString(query, val) {
      try {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set(query, String(val));
        window.history.pushState({ path: currentUrl.href }, '', currentUrl.href);
      } catch (e) {
        console.error('Error updating URL:', e);
      }
    }

    function isFiltering() {
      const params = new URLSearchParams(window.location.search);

      return params.has('sort_by') || Array.from(params.keys()).some((key) => key.startsWith('filter'));
    }

    function initProductCards() {
      if (isFiltering()) {
        $('#product-grid .image-block').hide();
        $('#product-grid').addClass('filtering');
      } else {
        $('#product-grid .image-block').show();
        $('#product-grid').removeClass('filtering');
      }

      if ($('.product-card-wrapper').length) {
        $('.product-card-wrapper').each(function () {
          $(this)
            .find('.card__options-btn')
            .click(function () {
              const quickAddEl = $(this).closest('.card-wrapper').find('.card__quick-add');
              if (!$(this).hasClass('active')) {
                $('.card__quick-add').removeClass('open');
                $('.card__options-btn.active').removeClass('active');
              }
              quickAddEl.toggleClass('open');
              $(this).toggleClass('active');
            });

          if ($(this).find('.card__size-options').length) {
            $(this)
              .find('.card__size-options')
              .each(function () {
                const _this = $(this);
                const sizeVariantValue = $(this).prev('.product-variant-id');

                $(this)
                  .find("input[type='radio']")
                  .on('change', function () {
                    const value = $(this).val();
                    sizeVariantValue.val(value);

                    _this.next('button').trigger('click');
                  });
              });
          }
        });
      }

      if ($('.card__media .card__slider').length) {
        $('.card__media .card__slider').each(function () {
          const opt = {
            slidesPerView: 'auto',
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          };
          if ($(this).hasClass('swiper-initialized')) {
            console.log(swiper);
            swiper.destroy();
          } else {
            swiper = new Swiper($(this)[0], opt);
          }
        });
      }

      $('.product-item').each(function () {
        const _this = $(this);

        if ($('.card__swatches .swatch__options .swatch-element').length) {
          $(this)
            .find('.card__swatches .swatch__options .swatch-element')
            .hover(
              function () {
                const id = $(this).data('id');
                const variantImages = _this.find('.card__variants-images');

                _this.find('.card__variants-images').addClass('active');
                variantImages.find(`img[data-id="${id}"]`).addClass('active').siblings('img').removeClass('active');
              },
              function () {
                _this.find('.card__variants-images').removeClass('active');
                _this.find('.card__variants-images img').removeClass('active');
              }
            );
        }
      });
    }

    initProductCards();

    if ($('.facet-filters__views-card').length) {
      $('.facet-filters__views-card div').click(function () {
        let activeElement = $('.facet-filters__views-card div.active').next().length
          ? $('.facet-filters__views-card div.active').next()
          : $('.facet-filters__views-card div.active').prev();
        $('.facet-filters__views-card div.active').removeClass('active');

        activeElement.addClass('active');

        const selectedView = $('.facet-filters__views-card div.active').data('view');

        handleProductCardView(selectedView);

        // Update URL with query string
        const url = new URL(window.location);
        url.searchParams.set('card-view', selectedView);
        window.history.pushState({}, '', url);
      });
    }

    function handleProductCardView(selectedView) {
      currentCardView = selectedView;

      $('.facet-filters__views-card div[data-view].active').removeClass('active');
      $(`.facet-filters__views-card div[data-view="${selectedView}"]`).addClass('active');

      $(".card__product-types").attr("data-current-view", selectedView);

      // $('.collection .card__media .init-slide').each(function () {
      //   var $this = $(this);
      //   if (selectedView === 'item') {
      //     $this.find('.media div a:has(img.model-img)').detach().appendTo($this.find('.media div')); // Append to the .media inside the current .card__media
      //   } else {
      //     $this.find('.media div a:has(img.model-img)').detach().prependTo($this.find('.media div')); // Prepend to the .media inside the current .card__media
      //   }
      // });
    }

    if ($('.products-slider-group .slick-slider')) {
      $('.products-slider-group .slick-slider').each(function () {
        $(this).slick({
          slidesToShow: 2,
          autoplay: true,
          autoplaySpeed: 5000,
        });
      });
    }

    if ($('.products-overlay').length) {
      $('.products-overlay-btn').each(function () {
        $(this).click(function () {
          if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $('.products-overlay').removeClass('active');
          } else {
            $('.products-overlay,.products-overlay-btn').removeClass('active');
            $(this).addClass('active');
            $(this).next('.products-overlay').toggleClass('active');
          }
        });
      });
    }

    if ($('.related-products-section')) {
      const targetNode = document.querySelector('.related-products-section');

      if (targetNode) {
        const config = {
          childList: true,
          subtree: true,
        };

        const callback = function (mutationsList, observer) {
          for (const mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
              mutation.addedNodes.forEach((node) => {
                const slider = node.querySelector ? node.querySelector('.card__media .card__slider') : null;
                if (slider) {
                  $('.related-products-section .card__media .card__slider').each(function () {
                    const swiper = new Swiper($(this), {
                      navigation: false 
                    })
                  });

                  if ($('.related-products-section .grid__item').length) {
                    $('.related-products-section .grid__item').each(function () {
                      $(this)
                        .find('.card__options-btn')
                        .click(function () {
                          const quickAddEl = $(this).closest('.card-wrapper').find('.card__quick-add');
                          if (!$(this).hasClass('active')) {
                            $('.card__quick-add').removeClass('open');
                            $('.card__options-btn.active').removeClass('active');
                          }
                          quickAddEl.toggleClass('open');
                          $(this).toggleClass('active');
                        });

                      if ($(this).find('.card__size-options').length) {
                        $(this)
                          .find('.card__size-options')
                          .each(function () {
                            const _this = $(this);
                            const sizeVariantValue = $(this).prev('.product-variant-id');

                            $(this)
                              .find("input[type='radio']")
                              .on('change', function () {
                                const value = $(this).val();
                                sizeVariantValue.val(value);

                                _this.next('button').trigger('click');
                              });
                          });
                      }
                    });
                  }
                }
              });
            }
          }
        };

        const observer = new MutationObserver(callback);

        observer.observe(targetNode, config);
      } else {
        console.warn('.related-products-section not found in the DOM.');
      }
    }

    $(window).resize(function () {
      initSlickSlider();
      initFooterToggle();
    });
  });

  $(window).on('load', function () {
    aos();
    scrollParallax();
    initFooterToggle();
  });

  $(window).on('scroll', scrollParallax);

  function aos() {
    AOS.init({
      // disable: 'mobile',
      once: true,
    });
  }

  function scrollParallax() {
    if ($('.full-width-image .bg-container').length) {
      var div = document.querySelector('.full-width-image'); // Adjust to target the correct container
      var topPos = div.getBoundingClientRect().top;
      var windowHeight = window.innerHeight;
      var scrolled = ((windowHeight - topPos) / windowHeight) * 100; // Calculate scroll offset

      // Make sure the parallax effect only happens when the div is in view
      if (topPos < windowHeight && topPos + div.offsetHeight > 0) {
        // Control the amount of parallax (adjust the divisor for more/less parallax effect)
        var parallaxOffset = scrolled / 6;

        // Apply the parallax transform to the background container
        $('.parallax-container').css('transform', 'translate3d(0, ' + parallaxOffset + '%, 0)');
      }
    }
  }

  function initFooterToggle() {
    if ($(window).width() < 767) {
      // Unbind previous click event to prevent duplicates
      $('.footer-block__heading')
        .off('click')
        .on('click', function (e) {
          e.preventDefault();
          var $heading = $(this);
          var $ul = $heading.next('ul');

          // Close all other uls and remove active class from other headings
          $('.footer-block__heading').not($heading).removeClass('active').next('ul').slideUp();

          // Toggle active class and open/close the current ul
          if ($heading.hasClass('active')) {
            $heading.removeClass('active');
            $ul.slideUp();
          } else {
            $heading.addClass('active');
            $ul.slideDown();
          }
        });
    } else {
      // Reset state when window width is greater than or equal to 767px
      $('.footer-block__heading').off('click'); // Remove click events
      $('.footer-block__heading').removeClass('active').next('ul').removeAttr('style'); // Reset styles
    }
  }

  function initSlickSlider() {
    if (window.innerWidth < 1024) {
      if (
        $('.product__column-sticky__complementary ul').length &&
        !$('.product__column-sticky__complementary ul').hasClass('slick-initialized')
      ) {
        $('.product__column-sticky__complementary ul').slick({
          infinite: false, // Infinite loop
          slidesToShow: 3,
          slidesToScroll: 1, // Scroll one slide at a time
          arrows: true, // Hide navigation arrows
        });
      }
    }

    if ($(window).width() < 767) {
      if ($('.mobile-banner-slider').length && !$('.mobile-banner-slider').hasClass('slick-initialized')) {
        $('.mobile-banner-slider').slick({
          dots: true, // Enable pagination dots
          infinite: true, // Infinite loop
          slidesToShow: 1, // Show one slide at a time
          slidesToScroll: 1, // Scroll one slide at a time
          arrows: false, // Hide navigation arrows
          autoplay: false, // Optional: autoplay slides
          autoplaySpeed: 3000, // Optional: delay between slides
        });
      }
    } else {
      if ($('.mobile-banner-slider').length && $('.mobile-banner-slider').hasClass('slick-initialized')) {
        $('.mobile-banner-slider').slick('unslick'); // Destroy the slider if above 767px
      }

      if ($('.product__column-sticky__complementary ul').hasClass('slick-initialized')) {
        $('.product__column-sticky__complementary ul').slick('unslick'); // Destroy the slider if above 767px
      }
    }
  }
})(window.jQuery);

$(window).load(() => {
  updateCSSVariables();

  $(window).resize(() => {
    updateCSSVariables();
  });
});

function updateUnderline() {
  var $activeLabel = $('.menu-drawer__navigation-label.active');

  if (!$activeLabel.length) return;

  var $underline = $('.menu-drawer__underline');

  // If it doesn't exist yet, create and append it
  if (!$underline.length) {
    $underline = $('<div class="menu-drawer__underline"></div>');
    $('.menu-drawer__navigation-header').append($underline);
  }

  var offset = $activeLabel.position();
  var width = $activeLabel.outerWidth();

  $underline.css({
    left: offset.left,
    width: width,
  });
}

function handleStickyHeader() {
  var $stickyHeader = $('sticky-header');
  if (!$stickyHeader.length) return;

  var threshold = 3; // pixels of buffer to reduce flickering

  function toggleStickyClass() {
    var headerTop = $stickyHeader[0].getBoundingClientRect().top;

    if (headerTop <= threshold) {
      $stickyHeader.addClass('is-sticky');
    } else {
      $stickyHeader.removeClass('is-sticky');
    }
  }

  // Throttle scroll/resize events
  let ticking = false;
  function onScrollOrResize() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        toggleStickyClass();
        ticking = false;
      });
      ticking = true;
    }
  }

  $(window).on('scroll resize', onScrollOrResize);
  toggleStickyClass(); // Initial run
}

function updateCSSVariables() {
  // TODO: Fix bug where the announcementBarHeight height value isn't matching it's true value. Or hardcode the header offset via SCSS
  // const announcementBarHeight = $('.utility-bar').length ? $('.utility-bar').outerHeight(true) : 0;
  // const headerHeight = $('.header-wrapper').outerHeight(true) || 0;
  const complementaryProductsHeight = $('.product__column-sticky__complementary').outerHeight(true) || 0;

  // if (headerHeight) {
  //   document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  // } else {
  //   console.warn('Header element not found!');
  // }

  if (complementaryProductsHeight) {
    document.documentElement.style.setProperty('--complementary-offset-top', `${complementaryProductsHeight}px`);
  }
}
